import { Dialog, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';
import React from 'react';
import * as yup from 'yup';
import { CancelSubmitFormDialogActions } from 'framework/forms/CancelSubmitFormDialogActions';
import { setFieldError } from 'framework/forms/utils/setFieldError';
import { IStrings } from 'localization/IStrings';
import { useLocalization } from 'localization/useLocalization';
import { FormSelectOrCreateGeneralPractitionerField } from './FormSelectOrCreateGeneralPractitionerField';

interface IModel {
	id: string;
}

const createSchema = (strings: IStrings) => {
	return yup.object<IModel>({
		id: yup.string().required(strings.formRequired(strings.entPhysician)),
	});
};

interface IProps extends DialogProps {
	initialId?: string;
	confirm: (id: string, setError: (error: string) => void) => void;
	cancel: VoidFunction;
	isSubmitting: boolean;
}

export const SelectGeneralPractitionerForm = ({ initialId, confirm, cancel, isSubmitting, ...rest }: IProps) => {
	const strings = useLocalization();

	const handleSubmit = (values: IModel, helpers: FormikHelpers<IModel>) => {
		confirm(values.id, (error: string) => setFieldError<IModel>('id', error, helpers));
	};

	return (
		<Formik<IModel>
			validateOnMount
			initialValues={{
				id: initialId ?? '',
			}}
			validationSchema={createSchema(strings)}
			onSubmit={handleSubmit}>
			<Form>
				<Dialog
					fullWidth
					{...rest}>
					<DialogTitle>{strings.selectWhat(strings.generalPractitioner)}</DialogTitle>
					<DialogContent
						dividers
						className='df-col'>
						<FormSelectOrCreateGeneralPractitionerField<IModel>
							name='id'
							label={strings.generalPractitioner}
						/>
					</DialogContent>
					<CancelSubmitFormDialogActions
						cancel={cancel}
						isSubmitting={isSubmitting}
						submitText={strings.link}
					/>
				</Dialog>
			</Form>
		</Formik>
	);
};
